<svg
  width="12px"
  height="7px"
  viewBox="0 0 12 7"
  version="1.1"
  xmlns="http://www.w3.org/2000/svg"
  xmlns:xlink="http://www.w3.org/1999/xlink">
  <g id="Symbols" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
    <g id="web/fields/dd-req" transform="translate(-318, -38)">
      <g id="web/icon/arrow-down" transform="translate(318, 38)">
        <rect id="Rectangle" x="0" y="0" width="12" height="7"></rect>
        <polyline
          id="Path"
          stroke="#000000"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          points="1 1 6 6 11 1"></polyline>
      </g>
    </g>
  </g>
</svg>
